import React from 'react';

const Input = ({
  type = 'text',
  placeholder = '',
  value = '',
  onChange,
  onBlur,
  label,
  error,
  disabled = false,
  required = false,
  icon,
  className = '',
  ...props
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="label">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-600">
            {icon}
          </span>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          className={`input-base ${icon ? 'pl-9' : ''} ${
            error ? 'input-error' : ''
          } ${disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : ''} ${
            className
          }`}
          {...props}
        />
      </div>
      {error && <span className="block text-sm text-danger mt-1">{error}</span>}
    </div>
  );
};

export default Input;
